"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_MESSAGES = exports.UNLINK_SOCIAL_ACCOUNT_SUCCESS = exports.LINK_SOCIAL_ACCOUNT_SUCCESS = exports.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE = exports.SIGN_IN_METHOD_APPLE_LOGIN = exports.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK = exports.SIGN_IN_METHOD_FACEBOOK_LOGIN = exports.SIGN_IN_METHOD_PASSWORD = void 0;

var _gettext = _interopRequireDefault(require("js-utils/gettext"));

var _SOCIAL_EXTERNAL_IDEN;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIGN_IN_METHOD_PASSWORD = 'password';
exports.SIGN_IN_METHOD_PASSWORD = SIGN_IN_METHOD_PASSWORD;
var SIGN_IN_METHOD_FACEBOOK_LOGIN = 'facebook_login';
exports.SIGN_IN_METHOD_FACEBOOK_LOGIN = SIGN_IN_METHOD_FACEBOOK_LOGIN;
var SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK = 'facebook';
exports.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK = SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK;
var SIGN_IN_METHOD_APPLE_LOGIN = 'apple_login';
exports.SIGN_IN_METHOD_APPLE_LOGIN = SIGN_IN_METHOD_APPLE_LOGIN;
var SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE = 'apple';
exports.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE = SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE;
var LINK_SOCIAL_ACCOUNT_SUCCESS = 'LINK_SOCIAL_ACCOUNT_SUCCESS';
exports.LINK_SOCIAL_ACCOUNT_SUCCESS = LINK_SOCIAL_ACCOUNT_SUCCESS;
var UNLINK_SOCIAL_ACCOUNT_SUCCESS = 'UNLINK_SOCIAL_ACCOUNT_SUCCESS';
exports.UNLINK_SOCIAL_ACCOUNT_SUCCESS = UNLINK_SOCIAL_ACCOUNT_SUCCESS;
var SOCIAL_EXTERNAL_IDENTITY_PROVIDER_MESSAGES = (_SOCIAL_EXTERNAL_IDEN = {}, _defineProperty(_SOCIAL_EXTERNAL_IDEN, LINK_SOCIAL_ACCOUNT_SUCCESS, _defineProperty({}, SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK, (0, _gettext.default)('Your Facebook account is successfully connected to Eventbrite.'))), _defineProperty(_SOCIAL_EXTERNAL_IDEN, UNLINK_SOCIAL_ACCOUNT_SUCCESS, _defineProperty({}, SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK, (0, _gettext.default)('Your Facebook account is successfully disconnected from Eventbrite.'))), _SOCIAL_EXTERNAL_IDEN);
exports.SOCIAL_EXTERNAL_IDENTITY_PROVIDER_MESSAGES = SOCIAL_EXTERNAL_IDENTITY_PROVIDER_MESSAGES;
//# sourceMappingURL=constants.js.map